export default "__VITE_ASSET__gKGnW$vf__"